import { defineMessages } from 'react-intl';

export default defineMessages({
    description: {
        id: 'ml.quoteandbind.seperateStructsNotRented.description',
        defaultMessage: 'Description'
    },
    limitOfInsurance: {
        id: 'ml.quoteandbind.seperateStructsNotRented.limitOfInsurance',
        defaultMessage: 'Limit Of Insurance'
    },
    structureType: {
        id: 'ml.quoteandbind.seperateStructsNotRented.structureType',
        defaultMessage: 'Structure Type'
    },
    action: {
        id: 'ml.quoteandbind.seperateStructsNotRented.action',
        defaultMessage: 'Action'
    },
    modalTitle: {
        id: 'ml.quoteandbind.seperateStructsNotRented.modalTitle',
        defaultMessage: 'Add Separate Structures Not Rented - On Premises'
    },
    addBtn: {
        id: 'ml.quoteandbind.seperateStructsNotRented.addBtn',
        defaultMessage: 'Add'
    },
    edit: {
        id: 'ml.quoteandbind.seperateStructsNotRented.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.seperateStructsNotRented.remove',
        defaultMessage: 'Remove'
    },
    continueBtn: {
        id: 'ml.quoteandbind.seperateStructsNotRented.continueBtn',
        defaultMessage: 'Continue'
    },
});
